import { create } from 'apisauce';

import { api, HEADERS, apiSetup } from '~config/api';

const { headers } = api;

const INTERVAL = 5000;
const TIMEOUT = 120000;

const getJobShow = ({ token }) => {
  const temporalApi = create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      [HEADERS.JOB_AUTHORIZATION]: token,
      [HEADERS.TENANT]: headers[HEADERS.TENANT]
    }
  });
  apiSetup(temporalApi);
  return temporalApi.get('/v1/orders_job');
};

export { getJobShow, INTERVAL, TIMEOUT };
